// EnquireForm.js

import SecondaryLogo from "../secondaryLogo/SecondaryLogo";

// import rose from '../assets/icons/rose.png';

const EnquireForm = (props) => {
    const { selectedProduct, setShowForm } = props;

    const product = selectedProduct[0].product.fields;

    const handleClose = () => {
        setShowForm(false);
    }

    return(
        <div className="form-backdrop">
            <div className="enquire-form">
                {/* <img src={rose} alt="rose logo" /> */}
                <SecondaryLogo />

                <div className="enquire-form__content">
                    <h2 className="enquire-form__heading">Contact Us</h2>
                    <p className="enquire-form__description">Get latest updates on new arrivals, special offers and more!</p>

                    <form name="contact" action="https://formspree.io/f/xwkavedl" method="POST">
                        <label htmlFor="name">
                            Your Name
                            <input type="text" name="name" id="name" className="name" required/>
                        </label>

                        <label htmlFor="phone number">
                            Phone No.
                            <input name="phone" id="phone" className="phone" pattern="[0-9]*" inputMode="numeric" placeholder="Enter your phone number" required />
                        </label>

                        <label htmlFor="message">
                            Message
                            <textarea type="text" name="message" id="message" className="message" defaultValue={`I would like to know more about ${product.productName}!`} required/>
                        </label>

                        <button className="enquire-form__close" type="button" aria-label="close" onClick={handleClose}>
                            <span aria-hidden="true">x</span>
                        </button>

                        <button className="enquire-form__buy primary-button" type="submit"><span>Submit Enquiry</span></button>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default EnquireForm;